module.exports = __webpack_public_path__ + "static/28-93df6acbe483d419ad55bf297b3e9bc3.jpg";